import { AppBar, Box, Button, Container, IconButton, Stack, Toolbar, Typography, styled } from '@mui/material'
import React from 'react'
import MenuIcon from '@mui/icons-material/Menu'
import HomeIcon from '@mui/icons-material/Home'
import { Lock } from '@mui/icons-material'
import { useValue } from '../context/ContextProvider'
import UserIcons from './user/UserIcons'
import { Link } from 'react-router-dom'
import MenuDrawer from './MenuDrawer'

/* Los diferentes Box que se encuentran dentro el AppBar */
const MenuBox = styled(Box)(({ theme }) => ({
    display: "flex",
    alignItems: "start",
    gap: "4px",
    //backgroundColor: "orange",
    [theme.breakpoints.down("lg")]: { display: "none" }, /* hace que se muestre el menu solo si el ancho es mayor a "lg" */
}));

/*   
*   Es para crear el tag MiLink, que es el link estilizado que se utiliza en el menu.  
*   El prop children se refiere al texto que está entre los tags, de modo que se pueda utilizar como:
*       <MiLink to={'/link'}> texto </MiLink>   Ej: <MiLink to={'/marcas'}>Marcas</MiLink>
*/
/*const MiLink = ({ to, children }) => {
    const StyledLink = styled(Link)({
        textDecoration: "none",
        color: "white",
        padding: "6px",
        "&:hover": {
            color: "#e7e7e7",
            backgroundColor: "#1976d2"
        }
    });

    return (
        <StyledLink to={to}>
            <Typography variant="h6" sx={{ display: { xs: "none", sm: "block" } }}>
                {children}
            </Typography>
        </StyledLink>

    )
}
*/


const NavBar = () => {

    //const permisos = ['superusuario', 'administrador'];

    let navBarButtons = [
        { "label": "POS", "to": "/pos", "permisos": ["superusuario", "administrador", "cajero"], "visibilidad": true },
        { "label": "Almacen", "to": "/almacen", "permisos": ["superusuario"], "visibilidad": true },
        { "label": "Productos", "to": "/gestion/productos", "permisos": ["superusuario", "administrador"], "visibilidad": true },
    ];

    const { state: { currentUser }, dispatch } = useValue();
    //const localPermiso = (permisos.includes(currentUser?.tipoUsuario));

    navBarButtons = navBarButtons.filter((nvButton) => {
        return nvButton.permisos.includes(currentUser?.tipoUsuario)
    })

    //console.log(navBarButtons);

    const toggleDrawer = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        dispatch({ type: 'OPEN_DRAWER' })
        //console.log('Open Drawer: ', open);
    };

    return (
        <>
            <AppBar position='static'>
                <Container maxWidth='100%' >
                    <Toolbar disableGutters >
                        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ width: '100vw' }} spacing={2}>
                            <Box width='33%' alignItems="center" sx={{ display: 'inline-flex', mr: 1 }}>
                                <IconButton size='large' color='inherit' aria-label='Drawer' onClick={toggleDrawer(true)}>
                                    <MenuIcon />
                                </IconButton>


                                {/* MenuBox muestra el menu en texto, que son shorcuts para los más utilizados (que también
                                están en el Drawer) este menu se oculta en pantallas inferiores a sx */}
                                <MenuBox>
                                    <Button component={Link} to="/" color='inherit' startIcon={<HomeIcon />} >
                                        Inicio
                                    </Button>
                                    {navBarButtons.map((nvButton) => (
                                        <Button key={nvButton.label} component={Link} to={nvButton.to} color='inherit'  >
                                            {nvButton.label}
                                        </Button>
                                    ))}

                                </MenuBox>

                            </Box>

                            <Box width='33%'>
                                <Typography variant='h6' component='h1' justifyContent="center" noWrap sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                                    Panadería "Barrio Lindo"
                                </Typography>
                                <Typography variant='h6' component='h1' justifyContent="center" noWrap sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                                    Panadería BL
                                </Typography>
                            </Box>
                            <Box width='33%' display='flex' justifyContent="end">
                                {!currentUser ? (
                                    <Button color='inherit' startIcon={<Lock />} onClick={() => dispatch({ type: 'OPEN_LOGIN' })}>
                                        Login
                                    </Button>
                                ) : (
                                    <UserIcons />
                                )}
                            </Box>
                        </Stack>
                    </Toolbar>
                </Container>
            </AppBar>
            <MenuDrawer />
        </>
    )
}

export default NavBar